// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/static/images/loaderLogo.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-loader {
  position: fixed;
  display: table;
  top: -40px;
  height: calc(100% + 40px);
  width: 100%;
  z-index: 1002;
  opacity: 1;
  -webkit-transition: background-color linear 0.5s;
  transition: background-color linear 0.5s;
  background-color: #FFF;
}
.app-loader__loader {
  width: 235px;
  height: 115px;
  top: 50%;
  left: 50%;
  margin-top: -58px;
  margin-left: -118px;
  background: #FFF;
  border-radius: 2px;
  position: absolute;
  text-align: center;
  padding: 32px;
}
.app-loader__spinner {
  display: inline-block;
  width: 50%;
  height: 100%;
  padding: 32px;
  margin: 0 auto;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  border: 1px solid #E8E9F0;
  background-color: #FFF;
  overflow: hidden;
}
.app-loader__logo {
  display: inline-block;
  width: 50%;
  height: 100%;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  float: left;
  padding: 16px;
  background: #002E33 center url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-size: 42px;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  border-right: 1px solid #002E33;
  border-top: 1px solid #002E33;
  border-bottom: 1px solid #002E33;
}
.app-loader__css-loader {
  margin: 0;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 0.5em solid #00E383;
  border-right: 0.5em solid #00E383;
  border-bottom: 0.5em solid #00E383;
  border-left: 0.5em solid #002E33;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
.app-loader__css-loader, .app-loader__css-loader:after {
  border-radius: 50%;
  width: 4em;
  height: 4em;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/AppLoader/styles.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,gDAAA;EAAA,wCAAA;EACA,sBCHI;ADER;AAGI;EACI,YAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBCZA;EDaA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AADR;AAII;EACI,qBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,8BAAA;UAAA,sBAAA;EACA,yBAAA;EACA,sBC3BA;ED4BA,gBAAA;AAFR;AAKI;EACI,qBAAA;EACA,UAAA;EACA,YAAA;EACA,8BAAA;UAAA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,4EAAA;EACA,qBAAA;EACA,4BAAA;EACA,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,gCAAA;AAHR;AAMI;EACI,SAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,+BAAA;EACA,iCAAA;EACA,kCAAA;EACA,gCAAA;EACA,gCAAA;EAEA,wBAAA;EACA,6CAAA;EACA,qCAAA;AAJR;AAOI;EAEI,kBAAA;EACA,UAAA;EACA,WAAA;AANR;AASI;EACI;IACI,+BAAA;IACA,uBAAA;EAPV;EASM;IACI,iCAAA;IACA,yBAAA;EAPV;AACF;AAUI;EACI;IACI,+BAAA;IACA,uBAAA;EARV;EAUM;IACI,iCAAA;IACA,yBAAA;EARV;AACF","sourcesContent":["@import '../../../Global/Colors.scss';\n\n.app-loader {\n    position: fixed;\n    display: table;\n    top: -40px;\n    height: calc(100% + 40px);\n    width: 100%;\n    z-index: 1002;\n    opacity: 1;\n    transition: background-color linear .5s;\n    background-color: $White;\n\n    &__loader {\n        width: 235px;\n        height: 115px;\n        top: 50%;\n        left: 50%;\n        margin-top: -58px;\n        margin-left: -118px;\n        background: $White;\n        border-radius: 2px;\n        position: absolute;\n        text-align: center;\n        padding: 32px;\n    }\n\n    &__spinner {\n        display: inline-block;\n        width: 50%;\n        height: 100%;\n        padding: 32px;\n        margin: 0 auto;\n        box-sizing: border-box;\n        border: 1px solid $Gray30;\n        background-color: $White;\n        overflow: hidden;\n    }\n\n    &__logo {\n        display: inline-block;\n        width: 50%;\n        height: 100%;\n        box-sizing: border-box;\n        float: left;\n        padding: 16px;\n        background: $DeepSeaGreen center url('/static/images/loaderLogo.svg') no-repeat;\n        background-size: 42px;\n        border-top-right-radius: 2px;\n        border-bottom-right-radius: 2px;\n        border-right: 1px solid $DeepSeaGreen;\n        border-top: 1px solid $DeepSeaGreen;\n        border-bottom: 1px solid $DeepSeaGreen;\n    }\n\n    &__css-loader {\n        margin: 0;\n        font-size: 10px;\n        position: relative;\n        text-indent: -9999em;\n        border-top: .5em solid $Green;\n        border-right: .5em solid $Green;\n        border-bottom: .5em solid $Green;\n        border-left: .5em solid $DeepSeaGreen;\n        -webkit-transform: translateZ(0);\n        -ms-transform: translateZ(0);\n        transform: translateZ(0);\n        -webkit-animation: load8 1.1s infinite linear;\n        animation: load8 1.1s infinite linear;\n    }\n\n    &__css-loader,\n    &__css-loader:after {\n        border-radius: 50%;\n        width: 4em;\n        height: 4em;\n    }\n\n    @-webkit-keyframes load8 {\n        0% {\n            -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n        }\n        100% {\n            -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n        }\n    }\n\n    @keyframes load8 {\n        0% {\n            -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n        }\n        100% {\n            -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n        }\n    }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
